import { useNode } from '@craftjs/core';
import { Stack } from '@mui/material';
import ContentSettings from './ContentSettings';
import { SettingCard, PreviewWidget, DisplayType } from '@/components'
import SpacingSettings from '@/components/editor/settings/SpacingSettings/SpacingSettings';
import ClassSettings from '@/components/editor/settings/ClassSettings';

const DishSettings = () => {
  const {
    displayType,
    previewWidget,
    actions: { setProp },
  } = useNode((node) => ({
    displayType: node.data.props.displayType,
    previewWidget: node.data.props.previewWidget,
  }));

  return (
    <Stack spacing={2}>
      {/* ✅ */}
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Espaciado">
        <SpacingSettings />
      </SettingCard>
      {/* ❌ */}
      <SettingCard title="Filtros">
        <ContentSettings />
      </SettingCard>
      <SettingCard title="Visualización">
        <PreviewWidget previewWidget={previewWidget} onChange={setProp} />
      </SettingCard>
      <SettingCard title="Visualización">
        <DisplayType displayType={displayType} onChange={setProp} />
      </SettingCard>
    </Stack>
  );
};

export default DishSettings;
